// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"e5d90962ec961687655e","240":"02cbbc270dbaa75d19a0"}[chunkId] + ".js";
};